// Element type lists we need synced between components and maintained in one place.
/**
 * Array of marquee child element types.
 * @type {string[]}
 */
export const marqueeChildElementTypes = ['marquee-text', 'marquee-image'];

/**
 * Array of element types without animation.
 * @type {string[]}
 */
export const elementTypesWithoutAnimation = [...marqueeChildElementTypes, 'sheet-data', 'sportradar'];

/**
 * Array of shape types.
 * @type {string[]}
 */
export const shapeTypes = ['rectangle', 'triangle', 'oval'];

/**
 * Array of data element types.
 * @type {string[]}
 */
export const dataElementTypes = [
  'sheet-data',
  'social-data',
  'sportradar',
  'linked-data',
  'shoppable',
];

/**
 * Array of element types without position.
 * @type {string[]}
 */
export const elementTypesWithoutPosition = [
  'slideshow',
  'sheet-data',
  'social-data',
  'sportradar',
  'linked-data',
  ...marqueeChildElementTypes,
];

/**
 * Array of element types allowed in a sheet data element.
 * @type {string[]}
 */
export const elementTypesAllowedInSheetData = ['data-list', 'marquee'];

/**
 * Array of element types not allowed in a group.
 * @type {string[]}
 */
export const elementTypesNotAllowedInGroup = ['group', 'slideshow', ...dataElementTypes];

/**
 * Array of illegal marquee parent types.
 * @type {string[]}
 */
export const illegalMarqueeParentTypes = ['sportradar', 'linked-data', 'social-data', 'shoppable'];

export const elementTypesNotAllowedInShoppable = [...elementTypesNotAllowedInGroup];
